import React from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs"; 
import { apiCall_domain } from "../api";
import TabsComments from "./TabsComments";
import TabsDetails from "./TabsDetails";
import TabsPrice from "./TabsPrice";
import axios from "axios";
class TabsCom extends React.Component {
    state={
        Comments:[]
    }
    componentDidMount() {
        const headers = {
            Authorization: localStorage.getItem("Api_key"),
            "content-type": "application/json",
          };
          axios
            .get(`${apiCall_domain}/customer/mechanics/comments?garage_id=${localStorage.getItem('garage_id')}`, {
              headers: headers,
            })
            .then((res)=>{
                this.setState({Comments:res.data.data})
            })
    }
    guildServicePrices(){
        this.props.props.history.push({
            pathname: "/multiVendor/categoryDetails/guildServicePrices",
            guildServicePrices:this.props.mechanicsInfgo
        })
    }
    render() {
        return (
            <div className="tabsCompCategoryDetails">
                <Tabs>
                    <TabList>
                        <Tab>جزئیات</Tab>
                        <Tab>قیمت ها</Tab>
                        <Tab>نظرات</Tab>
                    </TabList>
                    <TabPanel index={0}>
                        <TabsDetails props={this.props.props}  mechanicsInfgo={this.props.mechanicsInfgo} />
                    </TabPanel>
                    <TabPanel index={1}>
                        <TabsPrice mechanicsInfgo={this.props.mechanicsInfgo}/>
                        <span className="ViewUnionPrices"onClick={()=>this.guildServicePrices()}>مشاهده قیمت‌های اتحادیه</span>
                    </TabPanel>
                    <TabPanel index={2}>
                        <TabsComments Comments={this.state.Comments}/>
                    </TabPanel>
                </Tabs>
            </div>
        )
    }
}
export default TabsCom;